import script from "./AttributeEditorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttributeEditorDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AttributeEditorDialog.vue?vue&type=style&index=0&id=796246b0&lang=css"

const __exports__ = script;

export default __exports__